import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api/client';
import { useAuth } from '../contexts/AuthContext';

export function LoginPage() {
  const btnRef = useRef(null);
  const { loginWithCredential, user } = useAuth();
  const nav = useNavigate();
  const [err, setErr] = useState('');

  useEffect(() => { if (user) nav('/', { replace: true }); }, [user, nav]);

  useEffect(() => {
    let cancelled = false;
    async function init() {
      try {
        const { clientId } = await api.get('/auth/google-client-id');
        if (!clientId) { setErr('Google Client ID não configurado no backend'); return; }
        if (!window.google?.accounts?.id) {
          await new Promise((resolve, reject) => {
            const s = document.createElement('script');
            s.src = 'https://accounts.google.com/gsi/client';
            s.async = true;
            s.onload = resolve;
            s.onerror = reject;
            document.head.appendChild(s);
          });
        }
        if (cancelled) return;
        window.google.accounts.id.initialize({
          client_id: clientId,
          callback: async (resp) => {
            try {
              await loginWithCredential(resp.credential);
              nav('/', { replace: true });
            } catch (e) {
              setErr(e.message || 'Falha no login');
            }
          },
        });
        window.google.accounts.id.renderButton(btnRef.current, {
          theme: 'filled_blue',
          size: 'large',
          text: 'signin_with',
          shape: 'pill',
          width: 300,
          locale: 'pt-BR',
        });
      } catch (e) {
        setErr(e.message || 'Erro ao inicializar login');
      }
    }
    init();
    return () => { cancelled = true; };
  }, [loginWithCredential, nav]);

  return (
    <div className="login-bg">
      <div className="login-card">
        <div className="login-logo">C</div>
        <h1 className="login-title">Comunica PMI</h1>
        <p className="login-subtitle">Gestão de demandas da Secretaria de Comunicação<br />Prefeitura de Itapecerica-MG</p>
        <div className="center" ref={btnRef} />
        {err && (
          <p style={{ color: 'var(--c-danger)', fontSize: 13, marginTop: 16 }}>{err}</p>
        )}
        <p style={{ marginTop: 28, fontSize: 11, color: 'var(--c-text-soft)' }}>
          Use sua conta Google institucional
        </p>
      </div>
    </div>
  );
}
